import $http from '../assets/js/http'

export function getList (params, enableLoading = true) {
  $http.custom(params, {moduleId: '501', enableLoading: enableLoading})
  return $http.post('/putunit/query/list', params)
}

export default {
  getList
}



// WEBPACK FOOTER //
// ./src/api/putUnit.js